import {getDataView} from "../DataView/getDataView";

export function getTablePanelView(ctx: any) {
  return getDataView(ctx)?.tablePanelView;
}